import { FC, PropsWithChildren } from "react";

import { CLARITY_PROJECT_IDS } from "../../../../common/constants/clarity";
import { useCurrentUserContext } from "../../../../common/contexts/CurrentUserContext";
import { ClarityProvider } from "../../../../common/providers/ClarityProvider";

/**
 * ClarityProviderWrapper - Determines which Clarity project to use based on auth state
 *
 * This wrapper:
 * - Uses CLARITY_PROJECT_IDS.ORG_DASHBOARD_CONNECTED when user is authenticated (getUserTrpc not null)
 * - Uses CLARITY_PROJECT_IDS.ORG_DASHBOARD_NOT_CONNECTED when user is not authenticated
 *
 * This component must be used inside CurrentUserProvider to access the user context.
 */
export const ClarityProviderWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { firstPaymentDate, userIsLoading } = useCurrentUserContext();

  // Determine project ID based on authentication state
  const project = firstPaymentDate
    ? CLARITY_PROJECT_IDS.ORG_DASHBOARD_CONNECTED
    : CLARITY_PROJECT_IDS.ORG_DASHBOARD_NOT_CONNECTED;

  return (
    <ClarityProvider project={project} waitForInitialLoad={userIsLoading}>
      {children}
    </ClarityProvider>
  );
};
